(() => {
  const openers = new WeakMap();
  const closeHeaderMenus = (except) => {
    document.querySelectorAll('.cc-header-menu__disclosure[open]').forEach(menu => {
      if (menu !== except) menu.open = false;
    });
  };
  document.addEventListener('toggle', event => {
    if (event.target.matches('.cc-header-menu__disclosure[open]')) closeHeaderMenus(event.target);
  }, true);
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-header-navigation]')) closeHeaderMenus();
    else if (event.target.closest('a')) closeHeaderMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const navigation = event.target.closest('[data-header-navigation]');
    const menu = navigation?.querySelector('.cc-header-menu__disclosure[open]');
    if (!menu) return;
    event.preventDefault();
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('focusout', event => {
    const navigation = event.target.closest('[data-header-navigation]');
    if (navigation) queueMicrotask(() => {
      if (!navigation.contains(document.activeElement)) closeHeaderMenus();
    });
  });
  const initialise = (root = document) => {
    root.querySelectorAll('#menu-dialog, #search-dialog').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        requestAnimationFrame(() => {
          if (!document.querySelector('dialog[open]')) openers.get(dialog)?.focus();
        });
      });
    });
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('llcc:overlay:opening', {detail: {id: dialog.id}}));
      openers.set(dialog, opener);
      if (!dialog.open) dialog.showModal();
      (dialog.querySelector('input[type="search"]') || dialog.querySelector('[data-dialog-close]'))?.focus();
    }
    const close = event.target.closest('[data-dialog-close]');
    if (close) close.closest('dialog')?.close();
  });
  document.addEventListener('llcc:overlay:opening', event => {
    closeHeaderMenus();
    document.querySelectorAll('#menu-dialog[open], #search-dialog[open]').forEach(dialog => {
      if (dialog.id !== event.detail.id) dialog.close();
    });
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()));
  initialise();
})();

if (!customElements.get('cc-viewport-hero')) {
  customElements.define('cc-viewport-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const {signal} = this.controller;
      const measure = () => {
        const top = Math.max(0, this.getBoundingClientRect().top + window.scrollY);
        const preview = document.getElementById('PBarNextFrameWrapper');
        const bounds = preview?.getBoundingClientRect();
        const inset = bounds && getComputedStyle(preview).position === 'fixed' && bounds.width > 0 && bounds.bottom >= window.innerHeight - 1
          ? Math.min(bounds.height, window.innerHeight) : 0;
        this.style.setProperty('--hero-top-offset', `${top}px`);
        this.style.setProperty('--hero-preview-inset', `${inset}px`);
      };
      this.observer = new ResizeObserver(measure);
      const observeChrome = () => {
        this.observer.disconnect();
        ['shopify-section-header', 'shopify-section-announcement-bar', 'PBarNextFrameWrapper'].forEach(id => {
          const element = document.getElementById(id);
          if (element) this.observer.observe(element);
        });
        measure();
      };
      this.chromeObserver = new MutationObserver(observeChrome);
      this.chromeObserver.observe(document.body, {childList: true});
      window.addEventListener('resize', measure, {signal});
      document.addEventListener('shopify:section:load', observeChrome, {signal});
      document.addEventListener('shopify:section:unload', observeChrome, {signal});
      document.addEventListener('shopify:section:reorder', measure, {signal});
      observeChrome();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.chromeObserver?.disconnect();
    }
  });
}

if (!customElements.get('cc-swipe-gallery')) {
  customElements.define('cc-swipe-gallery', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-gallery-track]');
      const controls = this.querySelector('[data-gallery-controls]');
      if (!track || !controls) return;
      const previous = controls.querySelector('[data-gallery-step="-1"]');
      const next = controls.querySelector('[data-gallery-step="1"]');
      this.controller = new AbortController();
      const {signal} = this.controller;
      const update = () => {
        const end = track.scrollWidth - track.clientWidth;
        controls.hidden = end <= 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
      };
      track.addEventListener('scroll', update, {passive: true, signal});
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-step]');
        if (!button || button.disabled) return;
        const cards = Array.from(track.children);
        const offsets = cards.map(card => card.offsetLeft - cards[0].offsetLeft);
        const current = offsets.reduce((nearest, offset, index) =>
          Math.abs(offset - track.scrollLeft) < Math.abs(offsets[nearest] - track.scrollLeft) ? index : nearest, 0);
        const target = Math.max(0, Math.min(cards.length - 1, current + Number(button.dataset.galleryStep)));
        track.scrollTo({
          left: offsets[target],
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
